export const messages = {
  en: {
    affiliateProductManage: {
      queryCondition: 'Query Condition',
      selectAffiliateProduct: 'Please select affiliate product',
      query: 'Query',
      affiliateProduct: 'Affiliate Product',
      add: 'Add',
      id: 'ID',
      name: 'Name',
      sort: 'Sort',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete'
    },
    addAffiliateProduct: {
      title: 'Add Affiliate Product',
      productId: 'Product ID',
      productIdPlaceholder: 'Required, please enter product ID',
      productIdTip: 'Copy product ID from merchant product page',
      productIdRequired: 'Product ID is required',
      productIdMaxLength: 'Product ID is too long',
      seq: 'Sort',
      seqPlaceholder: 'Required, please enter sort number',
      seqRequired: 'Sort is required',
      seqPattern: 'Sort must be integer',
      cancel: 'Cancel',
      save: 'Save',
      saveSuccess: 'Save successfully'
    },
    editAffiliateProduct: {
      title: 'Edit Affiliate Product',
      product: 'Affiliate Product',
      productPlaceholder: 'Required, please enter affiliate product',
      productRequired: 'Affiliate product is required',
      productMaxLength: 'Affiliate product is too long',
      seq: 'Sort',
      seqPlaceholder: 'Required, please enter sort number',
      seqRequired: 'Sort is required',
      seqPattern: 'Sort must be integer',
      cancel: 'Cancel',
      save: 'Save',
      saveSuccess: 'Save successfully'
    },
    deleteAffiliateProduct: {
      confirmTitle: 'Please confirm your operation!',
      confirmText: 'Confirm to delete affiliate product?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    affiliateProductManage: {
      queryCondition: '查询条件',
      selectAffiliateProduct: '请选择分销商品',
      query: '查询',
      affiliateProduct: '分销商品',
      add: '添加',
      id: '编号',
      name: '名称',
      sort: '排序',
      operation: '操作',
      edit: '修改',
      delete: '删除'
    },
    addAffiliateProduct: {
      title: '添加分销商品',
      productId: '商品编号',
      productIdPlaceholder: '必填，请填写商品编号',
      productIdTip: '商家目录下的上架商品页面，复制商品ID',
      productIdRequired: '商品编号不能为空',
      productIdMaxLength: '商品编号太长',
      seq: '排序',
      seqPlaceholder: '必填，请填写排序',
      seqRequired: '排序不能为空',
      seqPattern: '排序必须是整数',
      cancel: '取消',
      save: '保存',
      saveSuccess: '保存成功'
    },
    editAffiliateProduct: {
      title: '修改分销商品',
      product: '分销商品',
      productPlaceholder: '必填，请填写分销商品',
      productRequired: '分销商品不能为空',
      productMaxLength: '分销商品不能超过30',
      seq: '排序',
      seqPlaceholder: '必填，请填写排序',
      seqRequired: '排序不能为空',
      seqPattern: '排序必须是整数',
      cancel: '取消',
      save: '保存',
      saveSuccess: '保存成功'
    },
    deleteAffiliateProduct: {
      confirmTitle: '请确认您的操作!',
      confirmText: '确定删除分销商品?',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功'
    }
  }
}